import { footprintCollidesWithRegion } from './collision';
import type { ActorFootprint, Point } from './geometry';
import type { RegionRegistry } from './region-registry';

export function recoverWorldPosition(
  point: Point,
  registry: RegionRegistry,
  footprintOrRadius: ActorFootprint | number,
): { point: Point; recovered: boolean; reason?: 'non-finite' | 'outside-world' | 'blocked' } {
  const footprint = typeof footprintOrRadius === 'number'
    ? { radiusX: footprintOrRadius, radiusY: footprintOrRadius }
    : footprintOrRadius;
  const radius = Math.max(footprint.radiusX, footprint.radiusY);
  const regions = registry.all();
  const finite = Number.isFinite(point.x) && Number.isFinite(point.y);
  const containing = finite
    ? regions.find((region) => point.x >= region.bounds.x && point.x < region.bounds.x + region.bounds.w && point.y >= region.bounds.y && point.y < region.bounds.y + region.bounds.h)
    : undefined;
  const region = containing ?? registry.get('meadow') ?? regions[0]!;
  const candidate = registry.clampPointToRegion(
    region.id,
    finite
      ? point
      : region.entrances[0]?.destinationPoint ?? {
          x: region.bounds.x + 180,
          y: region.bounds.y + 180,
        },
    radius,
  );
  const clamped = candidate.x !== point.x || candidate.y !== point.y;
  if (!footprintCollidesWithRegion(region, candidate, footprint)) {
    return finite && containing && !clamped
      ? { point: candidate, recovered: false }
      : { point: candidate, recovered: true, reason: finite ? 'outside-world' : 'non-finite' };
  }
  return { point: registry.nearestValidPoint(region.id, candidate, radius), recovered: true, reason: 'blocked' };
}
